/**
 * Status of a patient-portal account, mirroring the admin API's
 * `PatientPortalUserStatusType` enum (seeded 1–4). Keep the two in step.
 */
export enum PatientPortalUserStatusType {
  Active = 1,
  Pending = 2,
  Revoked = 3,
  Denied = 4,
}
